import React, { Component } from 'react';
import { DragSource } from 'react-dnd';
import { draggableResource, XResource } from '../../commonComponents';
import { EDIE_BLOCK_TYPE } from '@cimpress-technology/edie-processors';
import Icon from './icon_condition.svg';

class XConditionResource extends Component {
  render () {
    return draggableResource(this.props, <div>
      <XResource resourceName={'Condition'} resourceIcon={Icon} />
    </div>);
  }
}

const source = {
  beginDrag (_props) {
    return {
      resourceType: EDIE_BLOCK_TYPE.CONDITION
    };
  }
};

function collect (connect, monitor) {
  return {
    connectDragPreview: connect.dragPreview(),
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging()
  };
}

export default DragSource(EDIE_BLOCK_TYPE.CONDITION, source, collect)(XConditionResource);
